<reporter-modal
  [modalTitle]="'Incident Attachments Audit Logs'"
  modalClasses="modal-xxl"
  [show]="auditHistory !== undefined"
  [noFooter]="true"
  (onClose)="close.emit()">
  <div role="modal-body"
    class="audit-history">
    @if (auditHistory) {
      <div
        class="contents">
        <div class="results">
          @if (auditHistory.length === 0) {
            <div
              class="w-100 px-3 text-info">No records found.
            </div>
          }
          @if (auditHistory.length > 0) {
            <div
              class="results-table mb-3">
              <div class="results-count">{{ totalRecords }} records found</div>
              <div class="results-header"
                [class.pr-0]="noScrollbar">
                <div class="col-2">Date Changed</div>
                <div class="col-2">Question</div>
                <div class="col-1">Sequence</div>
                <div class="col-3">Old Attachment</div>
                <div class="col-3">New Attachment</div>
                <div class="col-1">User</div>
              </div>
              <div class="results-body pb-2"
                #resultsBody
                infiniteScroll
                [scrollWindow]="false"
                [infiniteScrollDistance]="2"
                [infiniteScrollThrottle]="50"
                [infiniteScrollDisabled]="totalPages < pageNumber"
                (scrolled)="loadNextPage()">
                @for (record of auditHistory; track record; let index = $index) {
                  <div
                    class="result-row">
                    <div class="result-cell col-2"
                    [attr.data-text]="record.modifiedTs">{{ record.modifiedTs }}</div>
                    <div class="result-cell col-2"
                    [attr.data-text]="record.questionKey">{{ record.questionKey }}</div>
                    <div class="result-cell col-1"
                    [attr.data-text]="record.sequenceNbr">{{ record.sequenceNbr }}</div>
                    <div class="result-cell col-3"
                    [attr.data-text]="record.newAttachment">{{ record.oldAttachment }}</div>
                    <div class="result-cell col-3"
                    [attr.data-text]="record.newAttachment">{{ record.newAttachment }}</div>
                    <div class="result-cell col-1"
                    [attr.data-text]="record.userId">{{ record.userId }}</div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</reporter-modal>
